module.exports = __webpack_public_path__ + "static/img/cyfw_index_01.91a517a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cyfw_index_01.png
// module id = 6EHL
// module chunks = 1